import { render, staticRenderFns } from "./OperaBannerZhuanquWindow.vue?vue&type=template&id=60a5d82e&scoped=true&"
import script from "./OperaBannerZhuanquWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBannerZhuanquWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaBannerZhuanquWindow.vue?vue&type=style&index=0&id=60a5d82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5d82e",
  null
  
)

export default component.exports